import React from "react";
import { WhatsappSquare } from "@styled-icons/fa-brands/WhatsappSquare";


const WhatsAppSquareIcon = ({size=12, ...props}: {size?: number}) => {
  return <WhatsappSquare size={size} color="#32d951" {...props}/>;
};

export default WhatsAppSquareIcon
